import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M6.69759 2.27914C7.27343 1.27142 8.72647 1.27142 9.30232 2.27914L14.7176 11.7558C15.289 12.7558 14.5669 14 13.4152 14H2.58474C1.433 14 0.710952 12.7558 1.28237 11.7558L6.69759 2.27914ZM8.74997 10.75C8.74997 11.1642 8.41418 11.5 7.99997 11.5C7.58576 11.5 7.24997 11.1642 7.24997 10.75C7.24997 10.3358 7.58576 10 7.99997 10C8.41418 10 8.74997 10.3358 8.74997 10.75ZM8.62497 5.5C8.62497 5.15482 8.34515 4.875 7.99997 4.875C7.65479 4.875 7.37497 5.15482 7.37497 5.5V8.5C7.37497 8.84518 7.65479 9.125 7.99997 9.125C8.34515 9.125 8.62497 8.84518 8.62497 8.5V5.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
